/* src/app/components/lead-details/participant-information/lead-pmpm-list/lead-pmpm-list.component.css */
/*# sourceMappingURL=lead-pmpm-list.component-KINEPYBO.css.map */
